import ForumIcon from '@app/assets/icons/ForumIcon'
import { appLink } from '@app/config/appLink'
import { useNavigate } from 'react-router-dom'
import Callout from '../components/Callout'
import HomeContent from '../../../../src/components/SectionContent'
import HeroBanner from '../components/HeroBanner'
import ModuleOverview from '../components/ModuleOverview'
import UseCaseCard from '../components/UseCaseCard'
import UseCaseCardGrid from '../components/UseCaseCardGrid'
import { USE_CASES } from '../config/useCases.config'
import { accentBgMap } from '../types'

const WelcomePage = () => {
  const navigate = useNavigate()

  return (
    <div>
      <HeroBanner />
      <UseCaseCardGrid>
        {USE_CASES.map((useCase) => (
          <UseCaseCard
            key={useCase.id}
            title={useCase.title}
            description={useCase.tagline}
            Icon={useCase.iconComponent}
            accentClassName={accentBgMap[useCase.accentColor]}
            onLearnMore={() => navigate(`${appLink.homeUseCases.path}/${useCase.id}/overview`)}
          />
        ))}
      </UseCaseCardGrid>
      <ModuleOverview />
      <HomeContent className="py-10">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8">
          <Callout
            title="Connect with other Resilience Explorer® users"
            description="Ask questions, share experiences, and learn from other risk and resilience practitioners."
            actionLabel="Visit Forum"
            icon={<ForumIcon />}
            onActionClick={() =>
              window.open('https://forum.resilience-explorer.com/', '_blank', 'noopener,noreferrer')
            }
          />
          <Callout
            title="Need help applying insights?"
            description="Urban Intelligence provides advisory support including risk assesments, investment prioritisation, and adaptation planning."
            actionLabel="Contact Us"
            onActionClick={() =>
              window.open(
                'https://resilience-explorer.com/contact',
                '_blank',
                'noopener,noreferrer',
              )
            }
          />
        </div>
      </HomeContent>
    </div>
  )
}

export default WelcomePage
